import store from '@/store'
import PayrollBase from '../components/ModuleBase'
import PayrollDashboard from '../views/Dashboard'

const routes = [
  {
    path: '/payroll/',
    component: PayrollBase,
    meta: { appKey: 'payroll' },
    beforeEnter: (to, from, next) => {
      store.dispatch('clearSubnav')
      next()
    },
    children: [
      {
        path: 'dashboard',
        component: PayrollDashboard,
        name: 'PayrollDashboard'
      }
    ]
  }
]

export default routes
